export default __webpack_public_path__ + "static/media/usersvg.cc15c73e.svg";